import createVueComponent from '../createVueComponent';
var Plus = createVueComponent('PlusIcon', [['line', {
  x1: '12',
  y1: '5',
  x2: '12',
  y2: '19',
  key: 'myz83a'
}], ['line', {
  x1: '5',
  y1: '12',
  x2: '19',
  y2: '12',
  key: '1smlys'
}]]);
export default Plus;